import React, { useState, useEffect } from 'react';

import * as api from '../../lib/api/api';
import FrameListView from './FrameListView';

const FrameList = ({ selectedFrame, inspectingLock, onSelectFrame }) => {
  const [frameList, setFrameList] = useState(null);

  useEffect(() => {
    getFrameList();
  }, []);

  const getFrameList = () => {
    api.getFrames().then((response) => {
      setFrameList(response.data);
    });
  };

  return (
    <FrameListView
      frameList={frameList}
      selectedFrame={selectedFrame}
      inspectingLock={inspectingLock}
      onSelectFrame={onSelectFrame}
    />
  );
};

export default React.memo(FrameList);
